import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripeCheckout from '../StripeCheckout';
import { Product } from 'ai-api/types/purchase';

// Stripe publishable keys
const test_PK = 'pk_test_51RMJLQEHF2kyRI5HVC7XZHF9pCHGavOQo3e1EvgYA6Rhs8bNs10cAqdnhwFLZ8JgvBc3WuOAYlyNHeSLbysCXt1M00Ov1Ziv5i';
const real_PK = 'pk_live_51RMJLQEHF2kyRI5HOvQxhGSrZPtxPzoQKYIXXMaYFSY3JuJJ5Q4bJRwKrWJ5Ww2C9NTHVeMucSPe7CxDbc9dqDCS00LZME45Uw';

// Initialize Stripe with publishable key
// Check if we're on the production domain (no subdomain)
const origin = typeof window !== 'undefined' ? window.location.hostname : '';
const isProduction = origin === 'koreanmate.app'; // Only true for exact match, not subdomains
const stripePromise = loadStripe(isProduction ? real_PK : test_PK);

interface StripeCheckoutWrapperProps {
    product: Product | null;
    clientSecret: string | null;
    onSuccess: () => void;
    onCancel: () => void;
}

const StripeCheckoutWrapper: React.FC<StripeCheckoutWrapperProps> = ({
    product,
    clientSecret,
    onSuccess,
    onCancel
}) => {
    return (
        <div className="payment-form-container">
            <Elements stripe={stripePromise}>
                <StripeCheckout
                    price={product?.finalAmount || 0}
                    productName={product?.name || ''}
                    clientSecret={clientSecret}
                    onSuccess={onSuccess}
                    onCancel={onCancel}
                />
            </Elements>
        </div>
    );
};

export default StripeCheckoutWrapper;